import React from "react";

interface AlertProps {
  variant?: "info" | "warning" | "error" | "success";
  children: React.ReactNode;
  className?: string;
}

/**
 * Alert component for displaying important notices and messages.
 * Follows ARIA alert pattern for screen reader accessibility.
 */
export default function Alert({
  variant = "info",
  children,
  className = "",
}: AlertProps) {
  const variantStyles = {
    info: "bg-blue-900/30 border-blue-700 text-blue-200",
    warning: "bg-yellow-900/30 border-yellow-700 text-yellow-200",
    error: "bg-red-900/30 border-red-700 text-red-200",
    success: "bg-green-900/30 border-green-700 text-green-200",
  };

  const variantIcons = {
    info: "ℹ️",
    warning: "⚠️",
    error: "❌",
    success: "✅",
  };

  return (
    <div
      role="alert"
      className={`w-full px-3 py-2.5 border-b text-xs ${variantStyles[variant]} ${className}`}
    >
      <div className="mx-auto flex items-start gap-2">
        <span className="flex-shrink-0">{variantIcons[variant]}</span>
        <div className="flex-1">{children}</div>
      </div>
    </div>
  );
}
